/**
 * Connect Buildium — placeholder.
 *
 * Deliberately not wired up. CLAUDE.md's Buildium migration strategy calls for a
 * read-only API key, and "never transform during extraction" — raw JSON lands in
 * object storage first, transforms run against that archive, and every import
 * upserts on `legacy_refs` so a re-run is idempotent rather than a second set of
 * duplicate rows. None of that exists yet; this screen names the shape it will take
 * so the form has somewhere to grow into once a key is in hand.
 */

import { useState } from 'react';
import { Link } from 'react-router';
import { Field, TextInput } from '../../../components/Form.js';

export function ImportBuildium() {
  const [apiKey, setApiKey] = useState('');

  return (
    <section className="stack">
      <div className="row">
        <h1>Connect Buildium</h1>
        <span className="shell__spacer" />
        <Link to="/staff/import" className="button button--quiet">
          ← Onboarding
        </Link>
      </div>

      <p className="alert alert--warn">
        Not built yet. This form is a placeholder for the real connection — nothing you enter here
        is sent anywhere.
      </p>

      <div className="card stack">
        <p className="muted">
          Once wired up, this reads owner and tenant contact records through a{' '}
          <strong>read-only</strong> Buildium API key. Every record it creates will be recorded in{' '}
          <code>legacy_refs</code> (source, entity table, external id), so a re-run upserts instead
          of creating duplicates — the same mapping table the balance-forward ledger migration uses,
          kept separate from that migration's own workstream.
        </p>

        <Field
          label="Buildium API key"
          name="apiKey"
          hint="Read-only key. Storing this is not implemented yet."
        >
          <TextInput
            name="apiKey"
            value={apiKey}
            onChange={setApiKey}
            disabled
            placeholder="Coming soon"
          />
        </Field>

        <div className="row">
          <button type="button" className="button" disabled>
            Connect
          </button>
        </div>
      </div>
    </section>
  );
}
